import { render, staticRenderFns } from "./Advertise.vue?vue&type=template&id=1a2acc14&scoped=true"
import script from "./Advertise.vue?vue&type=script&lang=js"
export * from "./Advertise.vue?vue&type=script&lang=js"
import style0 from "./Advertise.vue?vue&type=style&index=0&id=1a2acc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2acc14",
  null
  
)

export default component.exports